<template>
  <div>
    <div class="hm-headline">
      <span class="headline">任务管理</span>
      <span class="subhead">活动任务管理</span>
    </div>
    <el-card>
      <div class="panel flex item-center flex-between">
        <div class="button-wrapper">
          <el-button
            size="small"
            type="primary"
            icon="hmicon icon-jiahao"
            @click="toAdd"
            >新增任务</el-button
          >
        </div>
        <div class="form-wrapper flex">
          <el-date-picker
            class="mr10"
            size="small"
            style="width: 250px"
            value-format="yyyy-MM-dd"
            v-model="taskTime"
            placeholder="选择时间"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
          <el-input
            class="mr10"
            size="small"
            clearable
            placeholder="输入任务名称"
            v-model.trim="taskName"
            style="width: 150px"
          ></el-input>
          <el-button
            size="small"
            style="margin-right: 0px;"
            @click="reset"
            class="hmicon icon-zhongzhi reset"
          ></el-button>
          <el-button size="small" type="primary" @click="search"
            >查询</el-button
          >
        </div>
      </div>
      <div class="table">
        <div class="flex table-panel">
          <span
            class="btn"
            :class="{ active: activeTab === i }"
            @click="switchTab(i)"
            v-for="(v, i) in btnList"
            :key="i"
          >
            {{ v.name }}({{ i === 0 ? goingTask : outTask }})
          </span>
        </div>
        <div>
          <el-table border :data="taskList" style="width: 100%">
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              :index="index => index + (currentPage - 1) * pageSize + 1"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="taskName"
              label="任务名称"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="taskTime"
              label="任务时间"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="导购筛选"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="showGuiderFilterConditions(scope.row)"
                  >查看所有发放导购</el-button
                >
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="筛选模式"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="showFilterConditions(scope.row)"
                  >{{ scope.row.modelFormat }}</el-button
                >
              </template>
            </el-table-column>
            <el-table-column header-align="center" align="center" label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="edit(scope.row)">编辑</el-button>
                <el-button type="text" @click="remove(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="text-right">
        <el-pagination
          background
          layout="total,sizes,  prev, pager, next, jumper"
          :total="taskListTotal"
          @current-change="paging"
          :current-page="currentPage"
          ref="pagination"
        >
        </el-pagination>
      </div>
    </el-card>
    <el-dialog :title="title" :visible.sync="dialogVisible">
      <!-- 自动筛选客户 -->
      <div v-if="filterMode === 0">
        <div class="info-item">
          <div class="title">
            会员基础信息
          </div>
          <div class="content">
            <div>
              <span class="mr2">会员情况：{{ info.isMomFormat }}</span>
              <span class="mr2">宝宝性别：{{ info.babyGenderFormat }}</span>
              <span>宝宝年龄段：{{ info.babyAgeFormat }}</span>
            </div>
            <div>
              <span class="mr2">消费能力：{{ info.consumeLevelFormat }}</span>
              <span>客户活跃度：{{ info.memberActiveLevelFormat }}</span>
            </div>
          </div>
        </div>
        <div>
          <div class="title">
            会员消费信息
          </div>
          <div class="content">
            <div>
              <span class="mr2">品类筛选：{{ info.buyCategoryName }}</span>
              <span class="mr2">品牌筛选：{{ info.buyBrands }}</span>
              <span class="mr2">商品货号：{{ info.goodsSn }}</span>
              <span>商城会员筛选：{{ info.isStoreMemberFormat }}</span>
            </div>
            <div>购买时间筛选：{{ info.buyTime }}</div>
          </div>
        </div>
      </div>
      <!-- 手动筛选客户 -->
      <div v-if="filterMode === 1">
        <el-table border :data="taskFilterMemberList">
          <el-table-column
            header-align="center"
            align="center"
            prop="name"
            label="用户名"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="mobile"
            label="电话"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="source"
            label="名单来源"
          >
          </el-table-column>
        </el-table>
      </div>
      <!-- 筛选导购 -->
      <div v-if="filterMode === 2">
        <el-table border :data="taskBindGuiderList">
          <el-table-column
            header-align="center"
            align="center"
            prop="name"
            label="导购姓名"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="storeName"
            label="导购门店"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="mobile_phone"
            label="导购手机"
          >
          </el-table-column>
        </el-table>
      </div>
      <!--  -->
      <span slot="footer" class="flex flex-center">
        <el-button type="primary" @click="dialogVisible = false" size="small"
          >关闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  data() {
    return {
      taskTime: [],
      taskName: "",
      info: {},
      dialogVisible: false,
      currentPage: 1,
      activeTab: 0,
      filterMode: "",
      btnList: [
        { name: "进行中", active: false, count: 0 },
        { name: "已过期", active: false, count: 0 }
      ]
    };
  },
  computed: {
    ...mapState({
      offlineBrandList: state => state.rules.offlineBrandList
    }),
    ...mapGetters([
      "customerFeatureList",
      "removeTaskCode",
      "taskFilterMemberList",
      "taskFilterConditionInfo",
      "taskBindGuiderList",
      "goingTask",
      "outTask",
      "taskList",
      "taskListTotal",
      "taskBindGuiderTotal"
    ])
  },
  created() {
    this.dispatchQueryTask();
    this.$store.dispatch("querySpecialTarget");
    this.$store.dispatch("queryOfflineBrand");
  },
  watch: {
    removeTaskCode(val) {
      if (val === "0") {
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.dispatchQueryTask();
      }
      this.$store.commit("removeTask", "");
    },
    taskFilterConditionInfo(val) {
      if (val) {
        for (let key in val) {
          this.customerFeatureList.forEach(v => {
            if (val[key] === "0") {
              val[key + "Format"] = "所有";
            } else if (val[key] === v.featureCode) {
              val[key + "Format"] = v.featureName;
            }
          });
        }
        this.offlineBrandList.forEach(v => {
          if (val.buyBrands === "0") {
            val.buyBrands = "所有";
          } else if (val.buyBrands === String(v.id)) {
            val.buyBrands = v.name;
          }
        });
        switch (String(val.isStoreMember)) {
          case "0":
            val.isStoreMemberFormat = "所有";
            break;
          case "1":
            val.isStoreMemberFormat = "商城会员";
            break;
          case "2":
            val.isStoreMemberFormat = "非商城会员";
            break;
          default:
            break;
        }
        val.isMomFormat = val.isMom === 0 ? "有宝宝" : "孕期";
        val.buyTime = val.consumeDateStart
          ? val.consumeDateStart + "至" + val.consumeDateEnd
          : "";
        this.info = val;
      }
    }
  },
  methods: {
    toAdd() {
      this.$router.push({
        name: "newTask",
        query: { type: "add", taskId: "null", model: "null" }
      });
    },
    reset() {
      this.taskTime = [];
      this.taskName = "";
    },
    switchTab(index) {
      this.activeTab = index;
      this.dispatchQueryTask();
    },
    remove(v) {
      this.$confirm(
        `
        <div class="message">
          <div>确认将<strong style="color: #f56c6c">${v.taskName}</strong>作废？</div>
          <div>(注：作废后任务将删除，请慎重操作)</div>
        </div>`,
        "提示",
        {
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          // 删除
          this.$store.dispatch("removeTask", {
            taskId: v.taskId
          });
        })
        .catch(() => {});
    },
    edit(row) {
      this.$router.push({
        name: "newTask",
        query: { type: "edit", taskId: row.taskId, model: row.model }
      });
    },
    search() {
      this.dispatchQueryTask();
    },
    showGuiderFilterConditions(row) {
      this.$store.dispatch("queryTaskBindGuider", {
        taskId: row.taskId
      });
      this.dialogVisible = true;
      this.filterMode = 2;
      this.title = `${row.taskName}-导购筛选`;
    },
    showFilterConditions(row) {
      this.$store.dispatch("queryTaskFilterCondition", {
        taskId: row.taskId,
        model: row.model
      });
      this.dialogVisible = true;
      this.filterMode = row.model;
      this.title =
        row.model === 0
          ? `${row.taskName}-自动筛选会员`
          : `${row.taskName}-手动筛选会员`;
    },
    paging(page) {
      this.currentPage = page;
      this.dispatchQueryTask();
    },
    dispatchQueryTask() {
      this.$store.dispatch("queryTask", {
        pageNo: this.currentPage,
        pageSize: 10,
        startTime:
          (this.taskTime && this.taskTime.length > 0 && this.taskTime[0]) || "",
        endTime:
          (this.taskTime && this.taskTime.length > 0 && this.taskTime[1]) || "",
        taskName: this.taskName,
        status: this.activeTab
      });
    }
  }
};
</script>

<style scoped lang="scss">
.title {
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 0.8rem;
  padding-bottom: 0.5rem;
}
.title::before {
  content: "*";
  color: #f56c6c;
  margin-right: 0.5rem;
}

.info-item {
  margin-bottom: 2rem;
}

.mr2 {
  margin-right: 2rem;
}
</style>
